module.exports = __webpack_public_path__ + "media/images/webpage/coupons/howto-get-8a3b449e8e2a408d66480fe6e5de4722.webp";